import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const customerApi = createApi({
  reducerPath: 'customerApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_BASE_URL}/v1.0/external/customers`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().user.token;
      if (token) {
        headers.set('authorization', token);
      }
      return headers;
    },
  }),
  tagTypes: ['Customer'],
  endpoints: (builder) => ({
    getCustomerList: builder.query({
      query: ({ limit = 10, offset = 0, search = '' }) => ({
        url: `/`,
        params: { limit, offset, search },
      }),
      providesTags: ['Customer'],
    }),
    getCustomerNames: builder.query({
      query: () => `/names`,
      transformResponse: (response) => response.data,
      providesTags: ['Customer'],
    }),
  }),
});

export const {
  useGetCustomerListQuery,
  useGetCustomerNamesQuery
} = customerApi; 